import React, { Component, useContext } from 'react';
import { Link } from "react-router-dom";
import Profile_pic from './images/profile-avatar.png'
import dog from './images/dog.jfif'
import './css_files/profile.css'
import DogCard from './dog_card';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { Logout } from './firebase';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CountryContext from './country_context';
import { Button } from '@mui/material';


const dogcard_style = {
    height: '100px',
    width: '100px,'
}

const { height, width } = dogcard_style


const ProfileNav = (props) => {
    const context = useContext(CountryContext)

    return (

        <div className='container-fluid brand-yellow-box-shadow w-100'>
            <div className='row
             align-items-center justify-content-between py-0'>
                <div className='col-md-2'>
                    <div className='align-items-center justify-content-center pr-4'>
                        <Link style={{ color: props.color }} to='/home'>
                            <HomeOutlinedIcon />
                        </Link>
                    </div>
                </div>

                <div className='col-md-5'>
                    <div className='row align-items-center justify-content-center'>
                           <div className=' text-wrap px-5'>Welcome, <span className='brand-yellow-font'>{context.user_sql_details && context.user_sql_details.username}</span></div>
                  
                        {context.allowedAdminUser &&
                            <div className='mr-4'>
                                <Link to='/admin'>
                                    Admin
                                </Link>
                            </div>}

                        <div className='mr-4'>

                            {context.user_sql_details && context.user_sql_details.public_id ?
                                <img src={`https://res.cloudinary.com/daurieb51/image/upload/${context.user_sql_details.public_id}.png`}
                                    className='  img-fluid profile_pic_user2
                                    '
                                />
                                :
                                <img src={Profile_pic}
                                    className='  img-fluid profile_pic_user2'
                                />
                            }

                        </div>
                        <div className='align-items-center justify-content-center '>
                            <Link to='/profile' style={{ color: props.color }}
                                onClick={() => {
                                    Logout()
                                    console.log('loggin out')

                                }
                                }
                                className='' >
                                <LogoutIcon /> Logout</Link>
                        </div>
                    </div>
                </div>
            </div>




        </div >
    )




}



export default ProfileNav;